import { Injectable } from '@angular/core';
import { firstValueFrom, timeout } from 'rxjs';
import { UrlService } from '@service/url/url.service';
import { RestService } from 'cargo-chief-commons';

@Injectable({
	providedIn: 'root',
})
export class IpService {
	constructor(
		private urlService: UrlService,
		private restService: RestService
	) {}

	async getIpAddress(): Promise<string> {
		try {
			const url = this.urlService.getIpAddress();
			const response = await firstValueFrom(this.restService.GET(url).pipe(timeout(1500)));
			return response?.data?.ip ?? '';
		} catch (error) {
			console.error('Failed to fetch IP address:', error);
			return '';
		}
	}
}
